/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function r(r){return"url"in r&&"urlHash"in r?{...r,url:""}:r}export{r as discardUrlIfHasUrlHash};
